import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { getAppNotifications, updateNotificationStatus } from './api';
import { NotificationDataResponse } from './type';

// export const DASHBOARD_HEALTH_METRICS = 'dashboard-health-metrics';
export const APP_NOTIFICATIONS = 'app-notifications';

interface GetNotificationProps extends UseInfiniteQueryOptions {
  status?: 'read' | 'unread';
}

export const useGetNotifications = (
  props?: Omit<
    GetNotificationProps,
    'queryKey' | 'initialPageParam' | 'getNextPageParam'
  >
) => {
  return useInfiniteQuery({
    initialPageParam: 1,
    // getNextPageParam: (lastPage: any, _, lastPageParam: any) => {
    //   const pageSize = lastPage?.data?.length ?? 0;
    //   const totalCount = lastPage?.count ?? 0;
    //   if (pageSize === 0 || lastPageParam * pageSize >= totalCount) {
    //     return undefined;
    //   }
    //   return lastPageParam + 1;
    // },
    getNextPageParam: (lastPage: any) => {
      if (!lastPage?.next || lastPage?.current_page >= lastPage?.total_pages) {
        return undefined;
      }
      return lastPage.current_page + 1;
    },
    queryKey: [APP_NOTIFICATIONS, props?.status || 'all'],
    queryFn: async ({ pageParam = 1 }) => {
      if (typeof pageParam === 'number') {
        return await getAppNotifications({
          status: props?.status,
          page: pageParam,
        });
      }
    },
    select: (data: any) => {
      return {
        data: data?.pages?.flatMap((page: any) => page.data),
        count: data?.pages?.[0]?.count,
      };
    },
    gcTime: 0,
    ...props,
  }) as UseInfiniteQueryResult<NotificationDataResponse>;
};

export const useUpdateNotificationStatus = (
  props?: Omit<
    UseMutationOptions<any, Error, { notification_id: string[] }, unknown>,
    'mutationFn'
  >
) => {
  const queryClient = useQueryClient();
  // const {currentSdk} = useBinahConfigStore();

  return useMutation({
    mutationFn: updateNotificationStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [APP_NOTIFICATIONS] });
      queryClient.invalidateQueries({ queryKey: ['dashbaord-details'] });
      // queryClient.invalidateQueries({
      //   queryKey: [DASHBOARD_HEALTH_METRICS, 'health_metrics', currentSdk],
      // });
    },
    ...props,
  });
};
